import { AsyncThunk } from "@reduxjs/toolkit";

import { IModal } from "../../types/modal";
import { ConfirmThunkModal } from "../ConfirmThunkModal";

interface PaymentStatusChangeModalProps<TPayload> extends IModal {
  isPaid: boolean;
  thunk: AsyncThunk<any, TPayload, any>;
  payload: TPayload;
  translationKey: string;
  isUpdating?: (state: any) => boolean;
}

export const PaymentStatusChangeModal = <TPayload,>({
  isPaid,
  thunk,
  payload,
  translationKey,
  isUpdating,
  isModalVisible,
  toggleModalVisibility,
}: PaymentStatusChangeModalProps<TPayload>) => {
  return (
    <ConfirmThunkModal
      isPaid={isPaid}
      thunk={thunk}
      payload={payload}
      translationKey={translationKey}
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      isUpdating={isUpdating}
    />
  );
};
